import { create } from 'zustand';

interface EcoDropsState {
  user: any; // подставь свой тип, если есть
  chainConfig: any; // подставь свой тип, если есть
  setUser: (user: any) => void;
  setChainConfig: (config: any) => void;
}

// Создание стора
export const useEcoDropsStore = create<EcoDropsState>((set) => ({
  user: null,
  chainConfig: null,
  setUser: (user) => set({ user }),
  setChainConfig: (chainConfig) => set({ chainConfig }),
}));
